var map = {
	"./modules/booking/booking.module": [
		"../../../../../src/app/modules/booking/booking.module.ts",
		"booking.module",
		"common"
	],
	"./modules/contact/contact.module": [
		"../../../../../src/app/modules/contact/contact.module.ts",
		"contact.module"
	],
	"./modules/exchange-point/exchange-point.module": [
		"../../../../../src/app/modules/exchange-point/exchange-point.module.ts",
		"exchange-point.module"
	],
	"./modules/general/general.module": [
		"../../../../../src/app/modules/general/general.module.ts",
		"general.module"
	],
	"./modules/group-booking/group-booking.module": [
		"../../../../../src/app/modules/group-booking/group-booking.module.ts",
		"group-booking.module",
		"common"
	],
	"./modules/group-service/group-service.module": [
		"../../../../../src/app/modules/group-service/group-service.module.ts",
		"group-service.module"
	],
	"./modules/guided-tours/guided-tours.module": [
		"../../../../../src/app/modules/guided-tours/guided-tours.module.ts",
		"guided-tours.module",
		"common"
	],
	"./modules/historical-bookings/historical-bookings.module": [
		"../../../../../src/app/modules/historical-bookings/historical-bookings.module.ts",
		"historical-bookings.module",
		"common"
	],
	"./modules/service-line/service-line.module": [
		"../../../../../src/app/modules/service-line/service-line.module.ts",
		"service-line.module",
		"common"
	],
	"./modules/shuttle-service/shuttle-service.module": [
		"../../../../../src/app/modules/shuttle-service/shuttle-service.module.ts",
		"shuttle-service.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// C:/Repositories/wfa3/SupplierPortal/app/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main